module.exports = __webpack_public_path__ + "static/media/spinner-white.6754abad.svg";